export default class ApiEvents {
  static PRIVATE_TENANT = (tenant) => `private-${tenant}`;
  static PRIVATE_TENANT_USER = (tenant, userId) => `private-${tenant}.${userId}`;
  static PUBLIC = 'public';
}